import { cn } from '@repo/ui/utils'

export function H2({
  children,
  className,
  ...props
}: React.HTMLAttributes<HTMLHeadingElement> & {
  children: React.ReactNode
  className?: string
}) {
  return (
    <h2
      className={cn(
        'border-b-primary-100 text-primary-600 select-none scroll-m-20 border-b pb-2 text-2xl font-semibold tracking-tight first:mt-0',
        className,
      )}
      {...props}
    >
      {children}
    </h2>
  )
}
